export default __webpack_public_path__ + "static/media/mdttc-hero.85fb3fe8.png";